// Definição para o modal de busca de Imagens do Repositório da Empresa.
// Factory function - recebe idEmpresa como parâmetro.
// Usa o endpoint de grid paginado (/EmpresaImagens/empresa/{idEmpresa}/grid),
// que expõe todas as informações da imagem e permite filtros.
//
// ⚠️ Requer o parâmetro `busca` no endpoint de grid (backend), pois o
// CampoBusca dispara a busca textual com esse query param.

import { formatarDataBR } from '@/utils/useDataBR'
import { formatarProporcao } from '@/utils/imagemProporcao'

const formatarTamanho = (bytes) => {
  if (!bytes) return '-'
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export const criarConfigBuscaEmpresaImagem = (idEmpresa) => ({
  label: 'Imagem',
  placeholder: 'Nome, descrição ou tipo...',
  titulo: 'Selecionar Imagem do Repositório',
  endpointApi: `EmpresaImagens/empresa/${idEmpresa}/grid`,
  endpointFetchId: 'EmpresaImagens',
  idField: 'idEmpresaImagem',
  displayField: 'nomeAmigavel',
  descField: 'descricao',
  tamanho: 'xl',

  camposFiltro: [
    { label: 'Busca', model: 'busca', tipo: 'text' },
    {
      label: 'Tipo de Imagem',
      model: 'tipoImagem',
      tipo: 'select',
      optionsEndpoint: 'EmpresaImagens/tipos',
      optionsMapper: (t) => ({ value: t.tipoImagem, label: t.nomeAmigavel })
    }
  ],

  colunasGrid: [
    { header: 'ID', dataField: 'idEmpresaImagem', width: '60px' },
    { header: 'Tipo', dataField: 'nomeAmigavel', width: '160px' },
    { header: 'Descrição', dataField: 'descricao' },
    { header: 'Arquivo', dataField: 'nomeArquivoOriginal', width: '180px' },
    {
      header: 'Dimensões',
      dataField: 'larguraOriginal',
      width: '120px',
      align: 'center',
      formatter: (value, row) => (row.larguraOriginal ? `${row.larguraOriginal} × ${row.alturaOriginal} px` : '-')
    },
    {
      header: 'Proporção',
      dataField: 'larguraOriginal',
      width: '90px',
      align: 'center',
      formatter: (value, row) => formatarProporcao(row.larguraOriginal, row.alturaOriginal)
    },
    {
      header: 'Formato',
      dataField: 'formatoArquivo',
      width: '90px',
      align: 'center',
      formatter: (value) => (value || '').toUpperCase()
    },
    {
      header: 'Tamanho',
      dataField: 'tamanhoBytes',
      width: '100px',
      align: 'end',
      formatter: (value) => formatarTamanho(value)
    },
    {
      header: 'Upload',
      dataField: 'dataUpload',
      width: '120px',
      formatter: (value) => (value ? formatarDataBR(value) : '-')
    }
  ],

  autocomplete: {
    habilitado: true,
    minChars: 2,
    maxResults: 15,
    debounceMs: 350,
    campoBusca: 'busca',
    camposExibicao: [
      { dataField: 'nomeAmigavel', header: 'Tipo', width: '140px' },
      { dataField: 'descricao', header: 'Descrição' },
      { dataField: 'nomeArquivoOriginal', header: 'Arquivo' }
    ]
  }
})
